// Server Component errors reach the client with a generic message and a digest that
// correlates with the server-side log; the original message is stripped in production.
export const deriveErrorDigest = (error: unknown) => {
  if (
    error instanceof Error &&
    'digest' in error &&
    typeof error.digest === 'string'
  ) {
    return error.digest;
  }

  return undefined;
};
